<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="novedadMes?.fecha" 
            [DateEnd]="novedadMes?.fecha"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="novedadesMesHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [enableCut]=false
            [CurrentPeriod]="novedadMes?.id">
</iboxtools>

<app-novedades-mes-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                         [novedadesMes]="novedadesMes" 
                                                         [permisoEdicion]="permisoEdicion"
                                                         (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-novedades-mes-list>

<app-novedades-mes-detalle #ChildNovedadMesDetalle [novedadMes]="novedadMes" *ngIf="verDetalle" 
                          [enabledForm]="habilitarFormDetalle" 
                          [MensajeError]="MensajeError" 
                          [desdeAnterior]="desdeAnterior" 
                          [ingreso]="ingreso"
                          [anteriorRetroactividad]="anteriorRetroactividad" 
                          [grupoLiq]="gruposLiquidaciones" 
                          [novedadesInvalida]="novedadesInvalida">
</app-novedades-mes-detalle>

